/** Hệ số scale mm → đơn vị scene (kế thừa bản thử nghiệm). */
export const SCALE = 0.065;

/** Màu mặc định theo category khi part không trỏ material. */
export const DEFAULT_COLORS = {
  panel: '#deb887',
  door: '#f5deb3',
  hardware: '#9aa3ad',
  fallback: '#deb887',
} as const;
